import io from "socket.io-client";
const u = JSON.parse(localStorage.getItem("u") || "{}");

export default {
  install(Vue, options) {
    let socket = io(process.env.VUE_APP_ATT_SOCKET_URL, {
      withCredentials: true,
      extraHeaders: {
        Authorization: "Bearer " + u.api_token,
      },
    });
    Vue.prototype.$sisSocket = (method, channel, func) => {
      return socket[method]("sis-api:private-" + channel, func);
    };
  },
};
